import { TriangleAlert } from "lucide-react";
import type React from "react";

interface Props {
    isOpen: boolean;
    onConfirm: () => void;
    count: number;
    onClose: () => void;
    type: "employee" | "store"
}

const DeletionConfirmationModal: React.FC<Props> = ({
    isOpen,
    onClose,
    onConfirm,
    count,
    type
}) => {

    if (!isOpen) return null;

    return (
        <div className="modal">
            <div className="modal-body p-4 flex flex-col text-center gap-4">
                <div className="flex flex-col items-center gap-4">
                    <TriangleAlert size={64} color="red" />

                    <h1 className="text-2xl font-semibold text-primary">
                        {`Delete ${count} ${type} ${(count > 1) ? 's' : ''}?`}
                    </h1>

                    <p className="text-lg mt-4">
                        This action cannot be undone
                    </p>
                </div>

                <div className="flex justify-end gap-2 mt-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 rounded-md border"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded-md bg-red-800 text-white"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DeletionConfirmationModal;